import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import {
  List,
  ListBody,
  ListHeader,
  ListItemCont,
  ListHeaderItem,
  ListItemWithImage,
  ListBodyFishingEmpty,
  useTranslation,
  platformMessageStore,
  gameConfigStore,
} from '@pascal/pascal-core';
import { betStore } from '@pascal/pascal-core/shared/core/store';
import default_fish_for_bet_fair from '../../../../assets/images/default_fish.png';
import default_fish from '../../../../assets/images/default-fish.svg';
import { FISH_IMAGES } from '../../../../core/constants/fishImagesArray';
import { gameStore } from '../../../../store/gameStore';
import { TranslationKeys } from '../../../../enums/translationKeys';
import turkishEmptyImage from '../../../../assets/images/turkishPartner/empty-image.png';
import { brandedGameIds } from '../../../../enums/brandedPartners';

const EMPTY_CONTENT = (isRepliedGame) => new Array(isRepliedGame ? 12 : 10).fill(null);

export const ResultsWrapper = observer(() => {
  const { reportResult, currentRound } = gameStore;
  const { gameId } = gameConfigStore;
  const { isRepliedGame } = platformMessageStore;
  const { repliedBetData } = betStore;

  const t = useTranslation();

  useEffect(() => {
    return () => {
      if (reportResult[0]?.animation) {
        reportResult[0].animation = false;
      }
    };
  }, [reportResult]);

  const brandedPartnersEmptyFishImages = useMemo(() => {
    return {
      [brandedGameIds.turkish]: turkishEmptyImage,
      [brandedGameIds.betfair]: default_fish_for_bet_fair,
    };
  }, []);

  return (
    <List>
      <ListHeader>
        <ListHeaderItem title={currentRound?.roundId}>
          {`${t(TranslationKeys.RoundId)} ${
            isRepliedGame ? repliedBetData?.roundId : currentRound?.roundId
          }`}
        </ListHeaderItem>
      </ListHeader>
      <ListBody
        childrenForFishingEmpty={
          <ListBodyFishingEmpty>
            {EMPTY_CONTENT(platformMessageStore.isRepliedGame).map((_, index) => {
              return (
                <ListItemCont key={index} className='list-item-row-component'>
                  <ListItemWithImage
                    imageSrc={brandedPartnersEmptyFishImages[gameId] || default_fish}
                    forFishingEmpty
                  />
                </ListItemCont>
              );
            })}
          </ListBodyFishingEmpty>
        }
      >
        {reportResult.map((el, index) => {
          const fishResult = reportResult[index];
          const key = `${reportResult.length - index}${currentRound?.roundId}_${
            fishResult?.resultType
          }_${fishResult?.odd}`;
          return (
            <ListItemCont
              key={key}
              // style={fishResult?.animation ? {} : {animation: 'none', transition: 'none'}}
              className={`list-item-row-component ${
                fishResult?.animation ? 'fish-row-animation' : ''
              }`}
            >
              <ListItemWithImage
                forFishingEmptyActive={!index}
                odd={fishResult?.odd !== undefined ? `x${fishResult?.odd}` : ' '}
                imageSrc={FISH_IMAGES[fishResult?.resultType]}
              />
            </ListItemCont>
          );
        })}
      </ListBody>
    </List>
  );
});
